import { useEffect } from "preact/hooks";
import { route } from "preact-router";
import { useSessionStatus } from "../../platform/session";

/** Where a visitor without a session goes from a page that needs one; `/auth` sends them back afterwards. */
export const unauthorizedUrl = (path: string): string => `/auth?error=unauthorized&redirect=${encodeURIComponent(path)}`;

/** The path and query of the page the visitor is on. */
export const currentPath = (): string => window.location.pathname + window.location.search;

/**
 * Gates a page on a session. A signed-out visitor is sent to `/auth`; the answer is true only once a session
 * exists, so the page renders nothing for a visitor who is on the way out.
 */
export const useRequireSession = (): boolean => {
  const status = useSessionStatus();

  useEffect(() => {
    if (status === "signedOut") {
      route(unauthorizedUrl(currentPath()), true);
    }
  }, [status]);

  return status === "signedIn";
};
